import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent, AppState } from '@capacitor/app';
import { Geolocation } from '@capacitor/geolocation';
import { SplashScreen } from '@capacitor/splash-screen';
import { AdMob } from '@capacitor-community/admob';
import { Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';
import { AppService } from './app.service';
import { UserService } from './auth/user.service';
import { ForceUpdateService } from './services/force-update.service';
import { DomTranslationService } from './services/dom-translation.service';
import { AuthService } from './firebase/auth.service';
import { AdmobService } from './shared/adv/admob.service';
import { appRouteFromUrlOpen } from './app-url-open-routing';
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  background: string;
  content: HTMLElement | undefined;
  isPremium: boolean;
  isAdmin: boolean;
  private appResumeSubscription: any;
  private appUrlOpenSubscription: any;
  private lastHandledAppUrlRoute: string | null = null;

  showTravelingModal = false;
  travelingData = {
    travelingRandom: null,
    travelingTitle: '',
    travelingLink: '',
    travelingBg: '',
  };

  constructor(
    private service: AppService,
    private platform: Platform,
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private forceUpdateService: ForceUpdateService,
    private domTranslationService: DomTranslationService,
    private authService: AuthService,
    private admobService: AdmobService
  ) {
    this.initializeAdv();
    this.setupAppStateListeners();
  }

  setupAppStateListeners() {
    // Listen for app state changes to handle resume from standby properly
    this.appResumeSubscription = App.addListener(
      'appStateChange',
      (state: AppState) => {
        if (state.isActive) {
          // App resumed from background

          // Reset any cached verification states to prevent popup issues
          if (this.authService) {
            // Refresh the verification cache on app resume
            this.authService.clearVerificationCache();
          }
        }
      }
    );
  }

  async ngOnInit() {
    this.service.appBackground.subscribe(bg => {
      this.background = bg;
    });
    this.service.showTravelingModal.subscribe(isOpen => {
      this.showTravelingModal = isOpen;
    });
    this.service.travelingData.subscribe(data => (this.travelingData = data));

    // Initialize content element for menu drag functionality
    this.content = document.getElementById('content') as HTMLElement;

    if (this.platform.platforms().includes('ios')) {
      await this.printCurrentPosition();
    }

    this.service.detectUrl();
  }

  printCurrentPosition = async () => {
    const coordinates = await Geolocation.getCurrentPosition();
  };

  async initializeAdv() {
    this.userService.setUser();
    await this.platform.ready();
    setTimeout(async () => {
      SplashScreen.hide({
        fadeOutDuration: 0,
      });
      // if (
      //   this.platform.platforms().includes('capacitor') &&
      //   this.forceUpdateService.isUpdateAvailability()
      // ) {
      //   this.router.navigateByUrl('check-version');
      // }
    }, 1000);
    if (this.platform.platforms().includes('capacitor')) {
      AdMob.initialize({});

      AdMob.setApplicationMuted({
        muted: false,
      });

      AdMob.setApplicationVolume({
        volume: 0.5,
      });
    }

    this.admobService.startMobileFooterBannerController('app-component');

    this.setupAppUrlOpenRouting();
  }

  private async setupAppUrlOpenRouting() {
    this.appUrlOpenSubscription = await App.addListener(
      'appUrlOpen',
      (event: URLOpenListenerEvent) => this.handleAppUrlOpen(event.url)
    );

    const launchUrl = await App.getLaunchUrl();
    this.handleAppUrlOpen(launchUrl?.url);
  }

  private handleAppUrlOpen(url?: string) {
    if (!url) {
      return;
    }

    this.zone.run(() => {
      const route = appRouteFromUrlOpen(url);
      if (!route || route === this.lastHandledAppUrlRoute) {
        return;
      }

      this.lastHandledAppUrlRoute = route;
      this.router.navigateByUrl(route);
    });
  }

  ngOnDestroy() {
    // Remove all app event listeners
    if (this.appResumeSubscription) {
      this.appResumeSubscription.remove();
    }
    if (this.appUrlOpenSubscription) {
      this.appUrlOpenSubscription.remove();
    }
    App.removeAllListeners();
  }

  closeTravelingModal(e) {
    this.service.showTravelingModal.next(false);
  }
}

